import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/i-money1.jpg'
import _imports_1 from '../../../assets/images/arrowtopleft.svg'
import _imports_2 from '../../../assets/images/arrowtopright.svg'
import _imports_3 from '../../../assets/images/check.svg'
import _imports_4 from '../../../assets/images/imoji.svg'
import _imports_5 from '../../../assets/images/arrowbottomleft.svg'
import _imports_6 from '../../../assets/images/arrowbottomright.svg'


const _hoisted_1 = {
  key: 0,
  class: "app-opening-overlay"
}
const _hoisted_2 = {
  class: "row mx-auto mt-1",
  style: {}
}
const _hoisted_3 = { class: "col-12 col-md-8 col-lg-6 col-xl-7 col-xxl-6 col-xxxl-4" }
const _hoisted_4 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white authentication-card"
}
const _hoisted_5 = { class: "card-body letter-spacing row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_8 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_9 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_10 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_11 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "form-group col-12 col-md-6" }
const _hoisted_15 = { class: "form-group col-12 col-md-6" }
const _hoisted_16 = {
  key: 1,
  class: "form-group mt-10 mb-10 mb-sm-10 mb-md-25"
}
const _hoisted_17 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-12" }
const _hoisted_20 = {
  key: 0,
  class: "mb-15 mb-md-20"
}
const _hoisted_21 = {
  key: 0,
  class: "text-center operators-loading"
}
const _hoisted_22 = {
  key: 1,
  class: "text-center form-check form-check-primary mb-0 fs-md-15 fs-lg-16 mr-0 text-muted lh-1 operators-list d-flex flex-row align-items-center justify-content-center"
}
const _hoisted_23 = ["src", "onClick"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = {
  key: 1,
  class: "operator-img_div"
}
const _hoisted_31 = {
  key: 2,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_32 = {
  key: 3,
  class: "row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0"
}
const _hoisted_33 = {
  key: 4,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_34 = {
  key: 5,
  class: "row line-numbers bg-gray pt-1 pb-0 ps-25 pe-25 mb-0"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = {
  key: 6,
  class: "payment-waiting form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_39 = {
  key: 7,
  class: "form-group mt-10 mb-10 mb-sm-10 mb-md-25"
}
const _hoisted_40 = { class: "invalid-feedback" }
const _hoisted_41 = {
  key: 8,
  class: "row justify-content-center g-2"
}
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_45 = {
  key: 9,
  class: "mt-2"
}
const _hoisted_46 = {
  key: 10,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_47 = {
  key: 11,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_48 = {
  key: 12,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_49 = {
  key: 13,
  class: "row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0"
}
const _hoisted_50 = {
  key: 14,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_51 = { id: "body_receipt" }
const _hoisted_52 = { id: "body_first_section" }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { class: "section_content" }
const _hoisted_55 = { class: "section_content" }
const _hoisted_56 = { class: "section_content" }
const _hoisted_57 = { class: "section_content" }
const _hoisted_58 = { style: {"margin-top":"10%"} }
const _hoisted_59 = { class: "section_content_other" }
const _hoisted_60 = { id: "body_second_section" }
const _hoisted_61 = { class: "section_content_other1" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 2 }

import router from '@/router';
import { useRoute } from 'vue-router'
import axios from 'axios';
import { ref, reactive, inject, onMounted, onBeforeUnmount, nextTick, computed } from 'vue';
import html2pdf from "html2pdf.js";
import * as yup from 'yup';
import "intl-tel-input/build/css/intlTelInput.css";

import intlTelInput from 'intl-tel-input';
import { Operator } from "@/utils/Model";

import mtn from "../../../assets/images/operator/mtn1.png"
import wave from "../../../assets/images/operator/wave.png"
import orange from "../../../assets/images/operator/om1.png"
import moov from "../../../assets/images/operator/moov1.png"

import { validate_phone_number, formatDateFr } from "../../../utils/function";
const DEEP_LINK_SCHEME = 'izyapp://payment/encaissement/';
const APP_OPEN_TIMEOUT = 2500;


export default /*@__PURE__*/_defineComponent({
  __name: 'TicketContent',
  setup(__props) {

const backApi = inject('back');

const beRedirect = inject('beRedirect');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const name = ref('');
const errorsBis = { 'otp': "", 'amount': 0 };
const phone = ref("");
const operators = ref(new Array<Operator>());
const operatorsLoading = ref(true);
let operatorsTemp = new Array<Operator>();

let environment = process.env.VUE_APP_TEST
const selectedOperator = ref('');
if (process.env.VUE_APP_TEST == 'DEMO') {
  selectedOperator.value = 'WAVE';
}

let contrycode = '';
let contryIndicatif = ''
const step1 = ref(1);
const step2 = ref(0);
const step3 = ref(0);
const OTP_OPERATOR = ref(process.env.VUE_APP_OTP_OPERATOR);
const MTN_OPERATOR = ref(process.env.VUE_APP_MTN);
const MOOV_OPERATOR = ref(process.env.VUE_APP_MOOV);
const WAVE_OPERATOR = ref(process.env.VUE_APP_WAVE);
let checkoutId = "";
let publicToken: string | null = '';
const amount = ref(0);
const amountInit = ref(0);
const status = ref(null);
let countRetry = 0;
let linkGenerated = false;
let verify_transact;
let sampleInterval;
const btnLoad = ref(true);
let startingMinutes = ref(5);
let startingSeconds = ref(0);
const mins = ref(startingMinutes);
const secs = ref(startingSeconds);
let paymentUrl;
const wavePaymentUrl = ref('');
const showWavePaymentButton = ref(false);

const isMobile = ref(false);
const appOpening = ref(false);
const showGuichet = ref(false); 
const deepLink = ref('');

let autoRedirectTimer: ReturnType<typeof setTimeout> | null = null;

let itiInitialized = false;

const detectMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  const userAgentMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  const smallScreen = window.innerWidth <= 767;
  return userAgentMobile || smallScreen;
};

const displayGuichet = () => {
  appOpening.value = false;
  showGuichet.value = true;
  nextTick(() => initPhoneInput());
};

const startAppOpenFlow = () => {
  if (!publicToken) {
    displayGuichet();
    return;
  }

  appOpening.value = true;
  showGuichet.value = false;
  deepLink.value = DEEP_LINK_SCHEME + publicToken;

  try {
    window.location.href = deepLink.value;
  } catch (e) {
    console.warn("Redirection automatique bloquée par le navigateur.", e);
  }

  autoRedirectTimer = setTimeout(() => {
    if (!document.hidden) {
      displayGuichet();
    }
  }, APP_OPEN_TIMEOUT);
};

const initPhoneInput = () => {
  const inputc = document.querySelector("#phone") as HTMLInputElement | null;

  if (!inputc) {
    console.warn("Champ #phone introuvable. Report de l'initialisation d'intlTelInput.");
    return;
  }

  if (itiInitialized) return;
  itiInitialized = true;

  iti = intlTelInput(inputc, {
    onlyCountries: ["ci", "sn"],
    initialCountry: "auto",
    geoIpLookup: function (callback) {
      fetch("https://ipapi.co/json")
        .then(function (res) { return res.json(); })
        .then(function (data) { callback(data.country_code); })
        .catch(function () { callback("ci"); });
    }
  });

  initOperator('', inputc);

  iti.promise?.then(() => initOperator('', inputc));

  inputc.addEventListener("countrychange", function () {
    contryChange(iti.getSelectedCountryData());
  });
};

const handleVisibilityChange = () => {
  if (document.hidden && autoRedirectTimer) {
    clearTimeout(autoRedirectTimer);
    autoRedirectTimer = null;
  }
};
let iti;
const schema = yup.object({
  otp: yup.string(),
  amount: yup.number().required('Le montant est requis'),
});

const formValues = reactive({
  otp: "",
  amount: 0,
});

const isStep1Valid = computed(() => {
  return !!phone.value && phone.value.length > 0 && !!selectedOperator.value;
});

function operatorImg(operator) {
  let img;
  switch (operator) {
    case 'MTN':
      img = mtn;
      break;
    case 'WAVE':
      img = wave;
      break;
    case 'ORANGE':
      img = orange;
      break;
    case 'MOOV':
      img = moov;
      break;
    default:
      img = '';
      break;
  }
  return img;
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

function handlePhone(myvalue, tag) {
  if (!iti) return;
  const contry = iti.getSelectedCountryData()?.iso2;
  if (!contry) return;
  let phone_length = 0;
  switch (contry) {
    case 'ci':
      phone_length = process.env.VUE_APP_CI_PHONE_LENTGH;
      break;
    case 'sn':
      phone_length = process.env.VUE_APP_SN_PHONE_LENTGH;
      break;
    default:
      alert("Sélectionnez un pays");
  }
  validate_phone_number(myvalue, tag, phone_length)
}

function handleOperatorChange(operator) {
  selectedOperator.value = operator;
}

const filterOperatorsByCountry = (iso2?: string) => {
  const code = (iso2 || 'ci').toLowerCase();
  contrycode = code;
  operators.value = operatorsTemp.filter(
    (op) => (op.countryCode || '').toLowerCase() === code
  );
};

function contryChange(countryObject) {
  contryIndicatif = countryObject.dialCode;
  filterOperatorsByCountry(countryObject.iso2);
}

function initOperator(myValue?, tag?) {
  if (!iti) return; // ⚠️ Sécurité
  filterOperatorsByCountry(iti.getSelectedCountryData()?.iso2);
}

const next = () => {
  if (checkField()) {
    step1.value = 0;
    step2.value = 1;
    if (selectedOperator.value !== OTP_OPERATOR.value) {
      initTransaction();
      sampleInterval = setInterval(() => {
        if (secs.value > 0) {
          secs.value = secs.value - 1;
        }
        if (secs.value === 0) {

          if (mins.value < 0) {
            checkPublicTransactionStatus();
            clearInterval(verify_transact);
            clearInterval(sampleInterval);
            btnLoad.value = true;
            step3.value = 1;
            step2.value = 0;
            step1.value = 0;

          } else {
            mins.value = mins.value - 1;
            secs.value = 59;
            if ((mins.value - 1) === -1) {
              checkPublicTransactionStatus();
              clearInterval(verify_transact);
              clearInterval(sampleInterval);
              btnLoad.value = true;
              step3.value = 1;
              step2.value = 0;
              step1.value = 0;

            }

          }
        }
      }, 1000);

      return () => {
        clearInterval(sampleInterval);

      };
    }
  }
}

const goback = () => {
  step1.value = 1;
  step2.value = 0;
  step3.value = 0;
  showWavePaymentButton.value = false;
  wavePaymentUrl.value = '';
  router.go(0)
}

const openWavePayment = () => {
  if (wavePaymentUrl.value) {
    window.location.href = wavePaymentUrl.value;
  }
}
const checkField = () => {
  let result = true;
  if (selectedOperator.value == "") {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez sélectionner un opérateur.";
    result = false;
  }
  if (amount.value <= 0) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un montant valide.";
    result = false;
  }
  if (phone.value == "" || (phone.value.length < process.env.VUE_APP_CI_PHONE_LENTGH && contrycode == "ci") || (phone.value.length < process.env.VUE_APP_SN_PHONE_LENTGH && contrycode == "sn")) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un numéro valide.";
    result = false;
  }

  return result;
}

const checkFieldForm = () => {
  let result = true;
  if (selectedOperator.value == "") {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez sélectionner un opérateur.";
    result = false;
  }
  if (amount.value <= 0) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un montant valide.";
    result = false;
  }
  if (phone.value == "" || (phone.value.length < process.env.VUE_APP_CI_PHONE_LENTGH && contrycode == "ci") || (phone.value.length < process.env.VUE_APP_SN_PHONE_LENTGH && contrycode == "sn")) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un numéro valide.";
    result = false;
  }
  if (formValues.otp == "" && OTP_OPERATOR.value == selectedOperator.value) {
    errorId.value = "Erreur survenue";
    errors.value = "Veuillez entrer un code otp valide.";
    result = false;
  }
  return result;
}

const initTransaction = async () => {


  if (checkFieldForm()) {
    btnLoad.value = false;
    try {

      schema.validateSync(formValues);

      axios.post(backApi + '/public/transactions/init', {
        operator: selectedOperator.value,
        publicToken: publicToken,
        amount: amount.value,
        mobile: phone.value,
        operationType: parseInt(process.env.VUE_APP_PAYIN_OPTTYPE),
        countryCode: contrycode,
        otp: formValues.otp,
        successUrl: window.location.origin + "/transaction/success/" + publicToken,
        errorUrl: window.location.origin + "/transaction/failed/" + publicToken
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        if (response.status == 201) {
          checkoutId = response.data.checkoutId;

          if (selectedOperator.value == WAVE_OPERATOR.value || selectedOperator.value == OTP_OPERATOR.value || selectedOperator.value == MTN_OPERATOR.value || selectedOperator.value == MOOV_OPERATOR.value) {
            verify_transact = setInterval(checkPublicTransactionStatus, 10000);
          }

        }
      }).catch((error) => {
        btnLoad.value = true;
        if (error.response) {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      });


    } catch (error) {
      console.error(error);
      if (error.response) {
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
      }
      btnLoad.value = true;

    }
  }

};


const showPublicTransaction = (token) => {

  axios.get(backApi + '/public/transactions/' + token, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {
        amountInit.value = response.data.amount;
        amount.value = response.data.amount;
        status.value = response.data.paymentStatus;
        checkoutId = response.data.checkoutId;

      }

    }).catch((error) => {
      if (error.response) {
        errors.value = error.response.data;
        router.push('/');
      }
    });
}

const checkPublicTransactionStatus = () => {

  axios.get(backApi + '/public/transactions/' + publicToken, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {

        status.value = response.data.paymentStatus;
        countRetry += 1;
        if (selectedOperator.value == OTP_OPERATOR.value && (countRetry == 3 || status.value == "SUCCEEDED" || status.value == "FAILED")) {
          clearInterval(verify_transact);
          btnLoad.value = true;
          step3.value = 1;
          step2.value = 0;
          step1.value = 0;
        }
        if ((selectedOperator.value == MTN_OPERATOR.value || selectedOperator.value == MOOV_OPERATOR.value) && (status.value == "SUCCEEDED" || status.value == "FAILED")) {

          clearInterval(verify_transact);
          clearInterval(sampleInterval);
          btnLoad.value = true;
          step3.value = 1;
          step2.value = 0;
          step1.value = 0;

        }
        if (selectedOperator.value == WAVE_OPERATOR.value) {
          if (status.value == "SUCCEEDED" || status.value == "FAILED") {
            clearInterval(verify_transact);
            btnLoad.value = true;
            step3.value = 1;
            step2.value = 0;
            step1.value = 0;
          }
          if (linkGenerated == false) {
            if (response.data.paymentUrl !== "") {
              linkGenerated = true;
              paymentUrl = response.data.paymentUrl;
              const popup = window.open(paymentUrl, '_blank');
              if (!popup || popup.closed || typeof popup.closed === 'undefined') {
                wavePaymentUrl.value = paymentUrl;
                showWavePaymentButton.value = true;
                btnLoad.value = true;
              }
            }
          }

        }
        console.log(response.data);

      }

    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        errorId.value = error.response.data.errorId;
        errors.value = error.response.data.message;
      }
    });
}

const getOperators = () => {

  operatorsLoading.value = true;

  axios.get(backApi + '/public/operators/', {
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      operatorsTemp = response.data;
      console.log(response.data);

      if (iti && document.querySelector('#phone')) {
        initOperator('', document.querySelector('#phone'));
      }
      operatorsLoading.value = false;

    }).catch((error) => {
      operatorsLoading.value = false;
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')

        }

      }
    });
}

const PDFReceipt = ref<HTMLElement | null>(null);

const download_receipt = () => {
  const element = PDFReceipt.value;
  if (element) element.classList.remove("d-none");

  showPublicTransaction(publicToken)

  setTimeout(() => {
    showPublicTransaction(publicToken)

    const receiptEl = document.getElementById("receipt");
    if (!receiptEl) return;

    receiptEl.style.display = 'block';
    receiptEl.style.border = '1px solid #706F6F';

    const opt = {
      margin: [0, 0, 0, 0],
      filename: "receipt_" + publicToken + ".pdf",
      jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" },
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
    }

    html2pdf().set(opt).from(receiptEl).toPdf().save()
  }, 3000);
}


onMounted(() => {
  linkGenerated = false;
  showWavePaymentButton.value = false;
  wavePaymentUrl.value = '';
  operatorsLoading.value = true;
  const route = useRoute();
  publicToken = route.params.token;
  checkoutId = "";
  isMobile.value = detectMobile();

  if (isMobile.value && beRedirect === 'true') {
    console.log('fhfhfhfhhffhfhhfffffff==',beRedirect)
    document.addEventListener('visibilitychange', handleVisibilityChange);
    startAppOpenFlow();
  } else {
    console.log('FALSE FALSE==',beRedirect)
    displayGuichet();
  }
  getOperators();
  showPublicTransaction(publicToken);
});

onBeforeUnmount(() => {
  if (autoRedirectTimer) clearTimeout(autoRedirectTimer);
  document.removeEventListener('visibilitychange', handleVisibilityChange);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (appOpening.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "payment-waiting" }, [
            _createElementVNode("div", {
              class: "payment-waiting__ring",
              role: "status",
              "aria-label": "Chargement"
            }),
            _createElementVNode("div", {
              class: "payment-waiting__dots",
              "aria-hidden": "true"
            }, [
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span")
            ])
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (showGuichet.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[45] || (_cache[45] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center col-12 d-flex align-items-center justify-content-center gap-2" }, [
                  _createTextVNode(" Payez avec "),
                  _createElementVNode("img", {
                    src: "/img/izypay.png",
                    alt: "IzyPay",
                    class: "izypay-logo"
                  })
                ], -1)),
                _createElementVNode("div", _hoisted_6, [
                  (errors.value !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("h6", _hoisted_8, _toDisplayString(errorId.value), 1),
                        _createElementVNode("h6", _hoisted_9, _toDisplayString(errors.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (success.value !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("h6", _hoisted_11, _toDisplayString(success.value), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(initTransaction, ["prevent"])
                  }, [
                    (step1.value == 1 && (!status.value || status.value == 'PENDING'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, " Téléphone ", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "tel",
                              class: "form-control shadow-none rounded-0 text-black field w-100",
                              placeholder: "0708204050",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                              id: "phone",
                              onKeyup: _cache[1] || (_cache[1] = ($event: any) => (handlePhone($event.target.value, $event.target))),
                              onFocus: _cache[2] || (_cache[2] = ($event: any) => (initOperator($event.target.value, $event.target))),
                              onBlur: _cache[3] || (_cache[3] = ($event: any) => (handlePhone($event.target.value, $event.target)))
                            }, null, 544), [
                              [_vModelText, phone.value]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, "Montant", -1)),
                            (amountInit.value == 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  type: "number",
                                  class: _normalizeClass(["form-control shadow-none rounded-0 text-black field w-100", { 'is-invalid': errorsBis['amount'] }]),
                                  placeholder: "e.g. 5 000",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((amount).value = $event)),
                                  onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_unref(validate_phone_number)($event.target.value, $event.target))),
                                  required: ""
                                }, null, 34)), [
                                  [_vModelText, amount.value]
                                ])
                              : _createCommentVNode("", true),
                            (amountInit.value > 0)
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  type: "number",
                                  class: "form-control shadow-none rounded-0 text-black field w-100",
                                  placeholder: "e.g. 5 000",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((amount).value = $event)),
                                  onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_unref(validate_phone_number)($event.target.value, $event.target))),
                                  disabled: ""
                                }, null, 544)), [
                                  [_vModelText, amount.value]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (step1.value == 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          (_unref(environment) == 'PROD')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        (step1.value == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (operatorsLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[14] || (_cache[14] = [
                                    _createElementVNode("div", {
                                      class: "spinner-grow text-warning",
                                      style: {"width":"2rem","height":"2rem"},
                                      role: "status"
                                    }, [
                                      _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                                    ], -1),
                                    _createElementVNode("p", { class: "operators-loading__text" }, "Chargement des opérateurs...", -1)
                                  ]))]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        key: operator.id,
                                        src: operatorImg(operator.mnoName),
                                        class: "operator-logo",
                                        width: "50",
                                        height: "50",
                                        onClick: ($event: any) => (handleOperatorChange(operator.mnoName))
                                      }, null, 8, _hoisted_23))
                                    }), 128))
                                  ]))
                            ]))
                          : _createCommentVNode("", true),
                        (step1.value == 1 && (!status.value || status.value == 'PENDING'))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: next,
                              disabled: !isStep1Valid.value,
                              class: "w-100 default-btn transition fw-medium text-white rounded-1 d-block border border-warning btn-payer d-flex align-items-center justify-content-center gap-2 py-0 px-5",
                              style: {"background-color":"#fff","border-color":"#EB9355","border-width":"1px","border-style":"solid","height":"55px"}
                            }, [
                              (selectedOperator.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    (selectedOperator.value == OTP_OPERATOR.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(orange),
                                          class: "operator-img"
                                        }, null, 8, _hoisted_26))
                                      : _createCommentVNode("", true),
                                    (selectedOperator.value == MTN_OPERATOR.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: _unref(mtn),
                                          class: "operator-img"
                                        }, null, 8, _hoisted_27))
                                      : _createCommentVNode("", true),
                                    (selectedOperator.value == MOOV_OPERATOR.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 2,
                                          src: _unref(moov),
                                          class: "operator-img"
                                        }, null, 8, _hoisted_28))
                                      : _createCommentVNode("", true),
                                    (selectedOperator.value == WAVE_OPERATOR.value)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 3,
                                          src: _unref(wave),
                                          class: "operator-img"
                                        }, null, 8, _hoisted_29))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_30)),
                              _cache[15] || (_cache[15] = _createElementVNode("span", {
                                style: {"color":"#EB9355"},
                                class: "fw-medium"
                              }, "Payer", -1))
                            ], 8, _hoisted_24))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value == OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("h2", null, "Confirmation du paiement", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value == OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Suivez les étapes suivantes pour obtenir le code d’autorisation. 1. Pour générer un code temporaire, ouvrez l’appli Orange Money Afrique et cliquez sur Mon Compte, ou composez le #144*82# et lancez l’appel 2. Tapez votre code secret et validez 3. Veuillez copier et coller le code reçu par SMS dans le champ ci-dessous. "))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value !== OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("h2", null, "Vérification du paiement", -1),
                              _createElementVNode("a", {
                                href: "https://pay.wave.com/",
                                target: "_blank",
                                style: {"visibility":"hidden"},
                                id: "paymentlink",
                                rel: "noopener"
                              }, "payment", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value !== OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              (selectedOperator.value == MTN_OPERATOR.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Veuillez saisir votre code secret MTN Money pour confirmer le paiement."))
                                : _createCommentVNode("", true),
                              (selectedOperator.value == MOOV_OPERATOR.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Veuillez saisir votre code secret FLOOZ pour confirmer le paiement."))
                                : _createCommentVNode("", true),
                              (selectedOperator.value == WAVE_OPERATOR.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Vous serez redirigé dans quelques instants vers la page affichant le qrcode à scanner pour finaliser votre opération. si c'est pas le cas, veuillez cliquer sur le bouton \"Ouvrir la page de paiement Wave\" ci-dessous."))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value !== OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("div", {
                                class: "payment-waiting__ring",
                                role: "status",
                                "aria-label": "Chargement"
                              }, null, -1),
                              _createElementVNode("p", { class: "payment-waiting__text" }, "Vérification du paiement en cours", -1),
                              _createElementVNode("div", {
                                class: "payment-waiting__dots",
                                "aria-hidden": "true"
                              }, [
                                _createElementVNode("span"),
                                _createElementVNode("span"),
                                _createElementVNode("span")
                              ], -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value == OTP_OPERATOR.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, " Saisir le code reçu par SMS ", -1)),
                              _withDirectives(_createElementVNode("input", {
                                id: "otp",
                                type: "text",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black field", { 'is-invalid': errorsBis['otp'] }]),
                                placeholder: "**************",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formValues.otp) = $event)),
                                onBlur: _cache[9] || (_cache[9] = ($event: any) => (validate('otp'))),
                                onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_unref(validate_phone_number)($event.target.value, $event.target, 4)))
                              }, null, 34), [
                                [_vModelText, formValues.otp]
                              ]),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(errorsBis['otp']), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && !(selectedOperator.value == WAVE_OPERATOR.value && showWavePaymentButton.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", { class: "col-6" }, [
                                _createElementVNode("button", {
                                  onClick: goback,
                                  class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning btn-payer",
                                  style: {"background-color":"#fff","border-color":"#EB9355","border-width":"1px","border-style":"solid"}
                                }, [...(_cache[20] || (_cache[20] = [
                                  _createElementVNode("i", {
                                    class: "flaticon-chevron-1 mt-2",
                                    style: {"color":"#EB9355"}
                                  }, null, -1),
                                  _createElementVNode("span", {
                                    class: "align-baseline",
                                    style: {"color":"#EB9355"}
                                  }, "Retour", -1)
                                ]))])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("button", {
                                  class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 btn-payer",
                                  type: "submit",
                                  style: {"background-color":"#EB9355"},
                                  disabled: !btnLoad.value
                                }, [
                                  (!btnLoad.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                                    : _createCommentVNode("", true),
                                  _cache[21] || (_cache[21] = _createTextVNode(" Payer ", -1))
                                ], 8, _hoisted_43)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (step2.value == 1 && selectedOperator.value == WAVE_OPERATOR.value && showWavePaymentButton.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("button", {
                                type: "button",
                                onClick: openWavePayment,
                                class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 btn-payer",
                                style: {"background-color":"#EB9355"}
                              }, " Ouvrir la page de paiement Wave ")
                            ]))
                          : _createCommentVNode("", true),
                        (status.value && status.value == 'SUCCEEDED')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[22] || (_cache[22] = [
                              _createElementVNode("h2", { class: "text-center" }, [
                                _createElementVNode("i", {
                                  class: "flaticon-secure-shield",
                                  style: {"color":"green"}
                                })
                              ], -1),
                              _createElementVNode("h3", { class: "text-center" }, "Votre paiement a été approuvé", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (status.value && status.value == 'FAILED')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("h2", { class: "text-center" }, [
                                _createElementVNode("i", {
                                  class: "flaticon-cancel",
                                  style: {"color":"red"}
                                })
                              ], -1),
                              _createElementVNode("h2", { class: "text-center" }, "Votre paiement a échoué", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        ((status.value && (status.value == 'PROCESSING' || status.value == 'PENDING')) && step3.value == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("h2", { class: "text-center" }, [
                                _createElementVNode("i", {
                                  class: "flaticon-compare",
                                  style: {"color":"blue"}
                                })
                              ], -1),
                              _createElementVNode("h2", { class: "text-center" }, "Votre paiement est en cours", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (status.value && status.value != 'PENDING' && btnLoad.value == true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _createElementVNode("p", null, [
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-black fw-bold" }, "Opérateur : ", -1)),
                                _createElementVNode("span", null, _toDisplayString(selectedOperator.value), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "text-black fw-bold" }, "ID Transaction : ", -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref(checkoutId)), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-black fw-bold" }, "Date Paiement : ", -1)),
                                _createElementVNode("span", null, _toDisplayString(_unref(formatDateFr)(new Date())), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        ((status.value && status.value != 'PENDING') && step3.value == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("button", {
                                onClick: download_receipt,
                                class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning",
                                style: {"background-color":"#fff","border-color":"#EB9355","border-width":"1px","border-style":"solid"}
                              }, [...(_cache[28] || (_cache[28] = [
                                _createElementVNode("span", {
                                  class: "align-baseline",
                                  style: {"color":"#EB9355"}
                                }, "Télécharger le reçu", -1)
                              ]))])
                            ]))
                          : _createCommentVNode("", true),
                        (status.value && status.value != 'PENDING')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 15,
                              ref_key: "PDFReceipt",
                              ref: PDFReceipt,
                              id: "receipt",
                              class: "form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none"
                            }, [
                              _cache[44] || (_cache[44] = _createStaticVNode("<div id=\"header_receipt\" data-v-63ae5ba6><h2 style=\"padding:2% 5% 2% 5%;color:#fff;\" data-v-63ae5ba6><span data-v-63ae5ba6><img src=\"" + _imports_0 + "\" alt=\"logo-icon\" style=\"max-width:10%;\" data-v-63ae5ba6><span class=\"logo_text\" data-v-63ae5ba6>IZYPAY</span></span><span id=\"header_text\" data-v-63ae5ba6> REÇU DE TRANSACTION </span></h2></div>", 1)),
                              _createElementVNode("div", _hoisted_51, [
                                _cache[42] || (_cache[42] = _createStaticVNode("<div id=\"arrow-top-section\" data-v-63ae5ba6><span id=\"arrow-top-left\" class=\"section_content\" data-v-63ae5ba6><img src=\"" + _imports_1 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-63ae5ba6></span><span id=\"arrow-top-right\" class=\"section_content\" data-v-63ae5ba6><img src=\"" + _imports_2 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-63ae5ba6></span></div>", 1)),
                                _createElementVNode("div", _hoisted_52, [
                                  (name.value != '')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                                        _cache[29] || (_cache[29] = _createElementVNode("span", { class: "section_label" }, "BENEFICIAIRE", -1)),
                                        _cache[30] || (_cache[30] = _createTextVNode(" : ", -1)),
                                        _createElementVNode("span", _hoisted_54, _toDisplayString(name.value), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("p", null, [
                                    _cache[31] || (_cache[31] = _createElementVNode("span", { class: "section_label" }, "OPERATEUR", -1)),
                                    _cache[32] || (_cache[32] = _createTextVNode(" : ", -1)),
                                    _createElementVNode("span", _hoisted_55, _toDisplayString(selectedOperator.value), 1)
                                  ]),
                                  _createElementVNode("p", null, [
                                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "section_label" }, "TELEPHONE", -1)),
                                    _cache[34] || (_cache[34] = _createTextVNode(" : ", -1)),
                                    _createElementVNode("span", _hoisted_56, _toDisplayString(phone.value), 1)
                                  ]),
                                  _createElementVNode("p", null, [
                                    _cache[35] || (_cache[35] = _createElementVNode("span", { class: "section_label" }, "DATE", -1)),
                                    _cache[36] || (_cache[36] = _createTextVNode(" : ", -1)),
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(formatDateFr)(new Date())), 1)
                                  ]),
                                  _createElementVNode("p", _hoisted_58, [
                                    _cache[37] || (_cache[37] = _createElementVNode("span", { class: "section_label" }, "CODE DE TRANSACTION", -1)),
                                    _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(checkoutId)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("p", null, [
                                    _cache[38] || (_cache[38] = _createElementVNode("span", { class: "section_label" }, "MONTANT...................................... ", -1)),
                                    _createElementVNode("span", _hoisted_61, _toDisplayString(amount.value) + " F", 1)
                                  ]),
                                  (status.value === 'FAILED')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_62, [...(_cache[39] || (_cache[39] = [
                                        _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                        _createElementVNode("span", { class: "section_content_other1" }, [
                                          _createTextVNode("ECHEC "),
                                          _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: "logo-icon",
                                            style: {"max-width":"25%"}
                                          })
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (status.value === 'SUCCEEDED')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_63, [...(_cache[40] || (_cache[40] = [
                                        _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                        _createElementVNode("span", { class: "section_content_other1" }, [
                                          _createTextVNode("SUCCÈS "),
                                          _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: "logo-icon",
                                            style: {"max-width":"25%"}
                                          })
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (status.value === 'PROCESSING' || status.value === 'PENDING')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_64, [...(_cache[41] || (_cache[41] = [
                                        _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                        _createElementVNode("span", { class: "section_content_other1" }, [
                                          _createTextVNode("EN COURS "),
                                          _createElementVNode("img", {
                                            src: _imports_3,
                                            alt: "logo-icon",
                                            style: {"max-width":"25%"}
                                          })
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[43] || (_cache[43] = _createStaticVNode("<div id=\"body_third_section\" data-v-63ae5ba6><p data-v-63ae5ba6><span class=\"section_label\" data-v-63ae5ba6>MERCI POUR LA CONFIANCE !</span>  <span class=\"section_content\" data-v-63ae5ba6><img src=\"" + _imports_4 + "\" alt=\"logo-icon\" style=\"max-width:25%;\" data-v-63ae5ba6></span></p></div><div id=\"arrow-bottom-section\" data-v-63ae5ba6><span id=\"arrow-bottom-left\" class=\"section_content\" data-v-63ae5ba6><img src=\"" + _imports_5 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-63ae5ba6></span><span id=\"arrow-bottom-right\" class=\"section_content\" data-v-63ae5ba6><img src=\"" + _imports_6 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-63ae5ba6></span></div>", 2))
                              ])
                            ], 512))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})